


























































import { Component, Vue } from 'vue-property-decorator';

import { curPref, Preferences } from '@/services/Preferences';
import { Device } from '@/types/core';

import { DateTime } from 'luxon';
import { BssPage, BssService, curBssService } from '@/services/BssService';

import Loading from '@/components/Loading.vue';
import SearchBox from '@/components/SearchBox.vue';
import BssRow from '@/components/bss/BssRow.vue';
import VueError from '@/components/VueError.vue';
import PageNav from '@/components/PageNav.vue';
import NavBar from '@/components/NavBar.vue';
import BssRowMobile from "@/components/bss/BssRowMobile.vue";
import NumEntries from '@/components/NumEntries.vue';
import { CsvUtil } from '@/util/CsvUtil';
import moment from 'moment';
import fileDownload from 'js-file-download';
import _ from 'lodash';

@Component({
  components: {
    BssRowMobile,
    BssRow,
    SearchBox,
    VueError,
    PageNav,
    Loading,
    NavBar,
    NumEntries
  },
})
export default class BssList extends Vue {

  // our model
  dateTime = DateTime;
  pageSize = 20;
  error:string = '';
  // first move is always to refresh Data
  httpBusy:boolean = true;
  pageList:BssPage[] = [];
  curPage:BssPage = {} as BssPage;
  searchTerm = curPref.retrieve('v3-bss-search-term', '');
  reqNo:number = 0;

  public $refs!: {
    'search-box': SearchBox
  };
  
  // internal dependencies
  private bssService:BssService = curBssService;
  private csvUtil:CsvUtil = new CsvUtil();

  async mounted() {
    this.refreshData();
  }

  async refreshData() {

    this.error = '';
    this.httpBusy = true;

    // prevents unwanted effects from race conditions now the search bar hangs around
    const currentReq:number = this.reqNo + 1
    this.reqNo = currentReq

    const reply = await this.bssService.getBssList({
        pageSize:this.pageSize,
        filter: this.searchTerm});

    // if this request has not been superceded then continue
    if (currentReq === this.reqNo) {
      this.httpBusy = false;

      if(reply.httpCode === 403)
        return this.$router.push({name:'login'});

      if(reply.errorMsg)
        return this.error = `Unable to load base stations because ${reply.errorMsg}`;

      this.pageList = reply.bssPageList as BssPage[];

      // we set the current page
      if(this.pageList.length > 0)
        this.curPage = this.pageList[0];
    }
  }

  newSearchText(newSearchText:string) {

    curPref.store('v3-bss-search-term', newSearchText);
    this.searchTerm = newSearchText;
    this.refreshData();
  }

  exportList() {

    let allBssList = _.flatten(this.pageList.map(page => page.bssList))
      
    let csvExport = this.csvUtil.bssListToCsv(allBssList);

    let filename = `export-basestations-${moment().toISOString(true)}.csv`;

    fileDownload(csvExport, filename);
  }

  get showPageNav():boolean {
    return !this.httpBusy && (this.pageList.length > 0);
  }

  get showDataRows():boolean {
    return !this.httpBusy && (this.pageList.length > 0) && this.error === '';
  }

  get showNoMatches():boolean {
    return !this.httpBusy && this.pageList.length === 0 && this.searchTerm !== '' && this.error === '';
  }

  get showNoAccess():boolean {
    return !this.httpBusy && this.pageList.length === 0 && this.searchTerm === '' && this.error === '';
  }

  get numEntries():number {
    return this.pageList.map(page => page.bssList.length).reduce((acc, current) => acc+current, 0);
  }

  get showNumEntries():boolean {
    return !this.httpBusy;
  }

  get numEntriesExactNumber():boolean {
    return this.searchTerm === '';
  }
}
